import { InjectionToken } from '@angular/core';

/**
 * Interface for the annotate API configuration.
 */
export interface AnnotateServiceConfig {
  url: string;
}

/**
 * This injection token can be used to inject the annotate API configuration.
 */
export const ANNOTATE_CONFIG = new InjectionToken<AnnotateServiceConfig>('AnnotateServiceConfig');
